export default __webpack_public_path__ + "static/media/Image.f6a5023e.svg";